/* RANGGRATI product page interactions (rgg-pdp) */
(function () {
  function money(cents) {
    var fmt = (window.Shopify && window.Shopify.money_format) || (window.theme && window.theme.moneyFormat) || 'Rs. {{amount}}';
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.'); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts.join('.'), amount0 = parts[0];
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, amount0).replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount);
  }

  function initGallery(root) {
    var track = root.querySelector('[data-rgg-gal-track]');
    if (!track) return;
    var dots = root.querySelectorAll('.rgg-gal__dot');
    var cur = root.querySelector('[data-rgg-gal-current]');
    track.addEventListener('scroll', function () {
      if (track.scrollWidth <= track.clientWidth + 2) return;
      var i = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      if (cur) cur.textContent = i + 1;
    }, { passive: true });

    var lb = root.querySelector('[data-rgg-lightbox]');
    if (!lb) return;
    root.querySelectorAll('[data-rgg-zoom]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        lb.hidden = false; document.documentElement.classList.add('rgg-lb-open');
        var img = lb.querySelector('[data-lb-index="' + btn.dataset.rggZoom + '"]');
        if (img) setTimeout(function () { img.scrollIntoView({ block: 'start' }); }, 30);
        lb.querySelector('[data-rgg-lb-close]').focus();
      });
    });
    function close() { lb.hidden = true; document.documentElement.classList.remove('rgg-lb-open'); }
    lb.querySelector('[data-rgg-lb-close]').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lb.hidden) close(); });
  }

  function initForm(root) {
    var form = root.querySelector('.rgg-buy__form');
    var idInput = root.querySelector('[data-rgg-variant-id]');
    var qty = root.querySelector('[data-rgg-qty] input');
    root.querySelectorAll('[data-rgg-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.rggQtyStep, 10));
        qty.value = v;
      });
    });

    // Variants
    var vjson = root.querySelector('[data-rgg-variants-json]');
    if (vjson && idInput) {
      var variants = JSON.parse(vjson.textContent);
      root.querySelectorAll('[data-rgg-opt]').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var sel = [];
          root.querySelectorAll('[data-rgg-opt]:checked').forEach(function (c) { sel[+c.dataset.rggOpt] = c.value; });
          var label = root.querySelector('[data-rgg-opt-label="' + inp.dataset.rggOpt + '"]'); if (label) label.textContent = inp.value;
          var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
          if (!v) return;
          idInput.value = v.id;
          var now = root.querySelector('[data-rgg-price-now]'), was = root.querySelector('[data-rgg-price-was]'), off = root.querySelector('[data-rgg-price-off]');
          if (now) now.textContent = money(v.price);
          var sale = v.compare_at_price && v.compare_at_price > v.price;
          if (was) { was.hidden = !sale; if (sale) was.textContent = money(v.compare_at_price); }
          if (off) { off.hidden = !sale; if (sale) off.textContent = Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '% off'; }
          var sku = root.querySelector('[data-rgg-sku]'); if (sku) sku.textContent = v.sku || '—';
          var atc = root.querySelector('[data-rgg-atc]'), lbl = root.querySelector('[data-rgg-atc-label]'), bn = root.querySelector('[data-rgg-buy-now]');
          if (atc) { atc.disabled = !v.available; if (lbl) lbl.textContent = v.available ? (atc.dataset.label || lbl.dataset.orig || lbl.textContent) : 'Sold out'; }
          if (bn) bn.disabled = !v.available;
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString());
          if (v.featured_media) {
            var fig = root.querySelector('[data-media-id="' + v.featured_media.id + '"]');
            if (fig) fig.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          }
        });
      });
      var lbl0 = root.querySelector('[data-rgg-atc-label]'); if (lbl0) lbl0.dataset.orig = lbl0.textContent;
    }

    // Gift
    var gift = root.querySelector('[data-rgg-gift]');
    if (gift) {
      var msg = gift.querySelector('[data-rgg-gift-msg]');
      gift.querySelectorAll('input[type=radio]').forEach(function (r) {
        r.addEventListener('change', function () {
          var on = gift.querySelector('[data-rgg-gift-yes]').checked;
          msg.hidden = !on;
          msg.querySelectorAll('[data-rgg-gift-field]').forEach(function (f) { f.disabled = !on; });
        });
      });
    }

    // Buy now: add to cart, then go to checkout
    var buyNow = root.querySelector('[data-rgg-buy-now]');
    var err = root.querySelector('[data-rgg-buy-error]');
    if (buyNow && form) {
      buyNow.addEventListener('click', function () {
        buyNow.classList.add('is-loading'); if (err) err.hidden = true;
        var fd = new FormData(form);
        document.querySelectorAll('[form="' + form.id + '"]').forEach(function (f) { if (!f.disabled && f.name) fd.set(f.name, f.value); });
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function (e) { buyNow.classList.remove('is-loading'); if (err) { err.textContent = (e && (e.description || e.message)) || 'Something went wrong. Please try again.'; err.hidden = false; } });
      });
    }
  }

  function initShare(root) {
    root.querySelectorAll('[data-rgg-copy]').forEach(function (b) {
      b.addEventListener('click', function () {
        var url = b.dataset.rggCopy, toast = root.querySelector('[data-rgg-copy-toast]');
        function done() { if (toast) { toast.textContent = 'Link copied'; toast.classList.add('is-on'); setTimeout(function () { toast.classList.remove('is-on'); }, 2000); } }
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, done);
        else { var t = document.createElement('textarea'); t.value = url; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch (e) {} t.remove(); done(); }
      });
    });
  }

  function initRelated(sec) {
    if (sec.__rggRel) return; sec.__rggRel = true;
    var base = sec.dataset.base;
    sec.querySelectorAll('[data-rgg-reco]').forEach(function (track) {
      var intent = track.dataset.rggReco;
      fetch(base + '&intent=' + intent).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var res = doc.querySelector('[data-rgg-reco-result]');
        var cards = res ? res.innerHTML.trim() : '';
        if (!cards) {
          if (intent === 'complementary') { var t = sec.querySelector('[data-rgg-tab-complementary]'); if (t) t.hidden = true; }
          else { track.innerHTML = ''; var p = track.closest('.rgg-panel'); if (p && intent === 'related') { /* nothing similar: hide whole section if no other tabs */ var tabs = sec.querySelectorAll('.rgg-tab:not([hidden])'); if (tabs.length <= 1) sec.hidden = true; } }
          return;
        }
        track.innerHTML = cards;
        window.dispatchEvent(new Event('resize'));
      }).catch(function () {});
    });
  }

  // Keep the first `limit` visible characters of an element's HTML, cutting at a word end.
  function truncateHtml(el, limit) {
    var clone = el.cloneNode(true), count = 0, done = false;
    var walker = document.createTreeWalker(clone, NodeFilter.SHOW_TEXT, null), node, remove = [];
    while ((node = walker.nextNode())) {
      if (done) { remove.push(node); continue; }
      var t = node.nodeValue, len = t.replace(/\s+/g, ' ').length;
      if (count + len < limit) { count += len; continue; }
      var cut = Math.max(0, limit - count), sp = t.indexOf(' ', cut);
      node.nodeValue = (sp === -1 ? t : t.slice(0, sp)).replace(/[\s,;:.\-]+$/, '') + '…';
      done = true;
    }
    remove.forEach(function (n) { n.parentNode && n.parentNode.removeChild(n); });
    // Drop elements left empty after the cut (keep images/line breaks before it)
    var els = clone.querySelectorAll('*');
    for (var i = els.length - 1; i >= 0; i--) {
      var e = els[i];
      if (!e.textContent.trim() && !e.querySelector('img,video,iframe') && !/^(IMG|VIDEO|IFRAME|BR|HR)$/.test(e.tagName)) e.parentNode.removeChild(e);
    }
    return clone.innerHTML;
  }

  function initLayout(root) {
    var media = root.querySelector('.rgg-pdp__media'), info = root.querySelector('.rgg-pdp__info');
    function sticky() {
      if (!media || !info) return;
      [media, info].forEach(function (el) { el.style.position = ''; el.style.top = ''; });
      if (window.innerWidth < 990) return;
      var m = media.offsetHeight, i = info.offsetHeight;
      if (Math.abs(m - i) < 80) return;
      var el = m < i ? media : info, h = el.offsetHeight;
      el.style.position = 'sticky';
      el.style.top = Math.min(110, window.innerHeight - h - 24) + 'px';
    }
    // Character-limited "Read more" (Description block settings)
    root.querySelectorAll('[data-rgg-more-chars]').forEach(function (b) {
      var limit = parseInt(b.dataset.rggMoreChars, 10) || 400;
      var full = b.innerHTML;
      var total = (b.textContent || '').replace(/\s+/g, ' ').trim().length;
      if (total <= limit + 20) return;
      var short = truncateHtml(b, limit);
      b.innerHTML = short;
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'rgg-more'; btn.textContent = 'Read more';
      btn.setAttribute('aria-expanded', 'false');
      b.parentNode.appendChild(btn);
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        b.innerHTML = open ? short : full;
        btn.textContent = open ? 'Read more' : 'Read less';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (open) b.closest('details').scrollIntoView({ block: 'nearest' });
        sticky();
      });
    });
    // Height-based "Read more" for other open sections (e.g. Features)
    root.querySelectorAll('.rgg-acc[open]:not(.rgg-acc--wash) .rgg-acc__body:not([data-rgg-more-chars]):not([data-rgg-more="off"])').forEach(function (b) {
      if (b.scrollHeight <= 380) return;
      b.classList.add('is-clamped');
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'rgg-more'; btn.textContent = 'Read more';
      b.parentNode.appendChild(btn);
      btn.addEventListener('click', function () {
        var c = b.classList.toggle('is-clamped');
        btn.textContent = c ? 'Read more' : 'Read less';
        sticky();
      });
    });
    root.querySelectorAll('details').forEach(function (d) { d.addEventListener('toggle', sticky); });
    window.addEventListener('resize', sticky);
    window.addEventListener('load', sticky);
    sticky();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-rgg-pdp]').forEach(function (root) {
      if (root.__rggPdp) return; root.__rggPdp = true;
      initGallery(root); initForm(root); initShare(root); initLayout(root);
    });
    (scope || document).querySelectorAll('[data-rgg-related]').forEach(initRelated);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();